import { render, staticRenderFns } from "./DHQPrice.vue?vue&type=template&id=3f9618c7&scoped=true&"
import script from "./DHQPrice.vue?vue&type=script&lang=js&"
export * from "./DHQPrice.vue?vue&type=script&lang=js&"
import style0 from "./DHQPrice.vue?vue&type=style&index=0&id=3f9618c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9618c7",
  null
  
)

export default component.exports